module.exports = __webpack_public_path__ + "static/logo-2e70014b74ed8b9b0ce1c8729f59f6ec.svg";